bloomingville.iPaper = {
    api: null,
    apiSecret: 'MTY6ZjZhZjhhNjMtY2VmNC00ZjllLTlkNzMtZWRiNjM1NjM5MWEz',
    apiType: 'ipaper-flipbook-api',
    apiUrl: 'https://cdn.ipaper.io/api',
    isUserAuthenticated: jQuery( 'body' ).data( 'isUserAuthenticated' ),
    testMode: false,
    init: function () {
        if ( jQuery( '.js-ipaper-flipbook' ).length > 0 ) {
            bloomingville.iPaper.testMode = jQuery( '.js-ipaper-flipbook' ).data('pageid') === 8477;
            window.addEventListener('CookiebotOnLoad', function ( event ) {
                if(Cookiebot.consent.marketing){
                    if(jQuery('.e-section-impersonation').length === 0){
                        jQuery( '.js-ipaper-flipbook' ).addClass('max-height');
                    }
                    jQuery( '.js-bloomingville-not-authenticated-info-container' ).remove();
                    e4.require.js( e4.settings.require.handlebars, function () {
                        bloomingville.iPaper.event = e4.util.registerEvents( 'builded', 'ipaper' );
                        bloomingville.customInput.init();
                        e4.handlebars.registerHelpers('multiCompare compare');
                        e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-bloomingville-ipaper-productdetail #js-e-handlebars-tmpl-bloomingville-ipaper-addmulti');
                    });
                    bloomingville.iPaper.getIPaperAPI( document, 'script', bloomingville.iPaper.apiType, bloomingville.iPaper.apiUrl, bloomingville.iPaper.apiSecret );
                }
            });
        }
    },
    getIPaperAPI: function ( i, P, a, p, e, r ) {
        if ( i.getElementById( a = a + '-' + e ) ) {
            return;
        }
        r = i.querySelector( P ).parentNode.appendChild( i.createElement( P ) );
        r.id = a;
        r.async = 1;
        r.src = p + '/' + e + '.js';
    },
    onAPIReady: function ( iPaperAPI ) {
        bloomingville.iPaper.api = iPaperAPI;
        bloomingville.iPaper.api.updateEventSettings( {
            onPageElementClick: { preventDefault: false }
        } );
        bloomingville.iPaper.bindEvents();
    },
    bindEvents: function () {
        bloomingville.iPaper.api.onItemAdd = function ( data ) {
            if(data.productId.indexOf(',') > -1){
                bloomingville.iPaper.getMultiProductData(data);
            } else {
                bloomingville.iPaper.getProductData(data);
            }
        };
        jQuery('.js-bloomingville-ipaper-addmulti-modal').on('click', '.js-add-multitocart', function(event){
            bloomingville.iPaper.addMultiToCart();
        });

        jQuery('.js-bloomingville-ipaper-addmulti-modal').on('click', '.js-remove-product', function(event){
            jQuery(event.target).closest('.js-product-item').remove();
            if(jQuery('.js-bloomingville-ipaper-addmulti-modal').find('.js-product-item').length === 0){
                jQuery( '.js-bloomingville-ipaper-addmulti-modal' ).modal('hide');
            }
        });

        jQuery('.js-bloomingville-ipaper-productdetail-modal').on('submit', '.js-e-product-form-addtocart', function(event){
            event.preventDefault();
            var jForm = jQuery(event.target);
            var objFormData = {
                productId: jForm.find('input[name="ProductID"]').val(),
                quantity: jForm.find('input[name="Quantity"]').val()
            };
            bloomingville.iPaper.addToCart(objFormData);
        });
    },
    addToCart: function ( data ) {
        e4.cart.addProduct( {
            ProductID: data.productId,
            VariantID: '',
            Quantity: data.quantity
        } );
    },
    msg: {
        msHideModalDelay: 1200,
        show: function ( jsonData ) {
            var jElementIpaperDetailModal = jQuery( '.js-bloomingville-ipaper-productdetail-modal' );
            jElementIpaperDetailModal.find('.js-e-product-form-addtocart').remove();
            jElementIpaperDetailModal.find( '.js-bloomingville-ipaper-cart-msg').removeClass('d-none');
            bloomingville.iPaper.closeModal(bloomingville.iPaper.msg.msHideModalDelay);
      }
    },
    closeModalEvent: null,
    closeModal: function(intDelay){
        bloomingville.iPaper.closeModalEvent = setTimeout(function ( ) {
            jQuery( '.js-bloomingville-ipaper-productdetail-modal' ).modal('hide');
        }, intDelay);
    },
    clearCloseModalEvent: function(){
        if(bloomingville.iPaper.closeModalEvent != null){
            clearTimeout(bloomingville.iPaper.closeModalEvent);
            bloomingville.iPaper.closeModalEvent = null;
        }
    },
    addmultiData: {},
    getMultiProductData: function(data){
        bloomingville.iPaper.addmultiData = {};
        var objProductDataSettings = {
            ProductIds: data.productId
        };
        jQuery.ajax( {
            method: 'GET',
            url: e4.settings.ecom.productlist.url,
            dataType: 'json',
            data: objProductDataSettings,
            beforeSend: function () {
                jQuery( '.js-bloomingville-ipaper-addmulti' ).empty();
                jQuery('.js-bloomingville-ipaper-addmulti-modal').find('.js-e-loading-overlay').addClass( 'is-loading' );
                jQuery('.js-bloomingville-ipaper-addmulti-modal').modal('show');
            },
        } ).done( function ( jsonData ) {
            jQuery('.js-bloomingville-ipaper-addmulti').html(e4.handlebars.tmpl.bloomingvilleIpaperAddmulti( jsonData ));
            jQuery('.js-bloomingville-ipaper-addmulti').trigger( bloomingville.iPaper.event.builded );
            jQuery('.js-bloomingville-ipaper-addmulti-modal').find('.js-e-loading-overlay').removeClass( 'is-loading' );
        } );
    },
    addMultiToCart: function(){
        var postData = {};
        postData['CartCmd'] = 'addmulti';
        jQuery('.js-bloomingville-ipaper-addmulti').find('.js-input-quantity').each(function(intIndex, domElement){
            var jElement = jQuery(domElement);
            postData['ProductLoopCounter'+intIndex] = intIndex;
            postData['ProductID'+intIndex] = jElement.data('id');
            postData['VariantID'+intIndex] = '';
            postData['UnitID'+intIndex] = '';
            postData['Quantity'+intIndex] = jElement.val();
        });
        e4.cart.addProduct(postData);
        jQuery( '.js-bloomingville-ipaper-addmulti-modal' ).modal('hide');
    },
    getProductData: function(data){
        bloomingville.iPaper.clearCloseModalEvent();
        var objProductDataSettings = {
            ProductID: data.productId
        };
        jQuery.ajax( {
            method: 'GET',
            url: e4.settings.ecom.product.url,
            dataType: 'json',
            data: objProductDataSettings,
            beforeSend: function () {
                jQuery( '.js-bloomingville-ipaper-productdetail' ).empty();
                jQuery('.js-bloomingville-ipaper-productdetail-modal').find('.js-e-loading-overlay').addClass( 'is-loading' );
                jQuery('.js-bloomingville-ipaper-productdetail-modal').modal('show');
            },
            complete: function(jsonData, statusCode) {
                if(statusCode === 'error'){
                    bloomingville.iPaper.jsonData = jsonData;
                    jQuery('.js-bloomingville-ipaper-productdetail-modal').find('.js-e-loading-overlay').removeClass( 'is-loading' );
                    bloomingville.iPaper.build( jsonData );
                    bloomingville.iPaper.closeModal(2400);
                }
            }
        } ).done( function ( jsonData ) {
            bloomingville.iPaper.jsonData = jsonData;
            jQuery('.js-bloomingville-ipaper-productdetail-modal').find('.js-e-loading-overlay').removeClass( 'is-loading' );
            bloomingville.iPaper.build( jsonData );
        } );
    },
    jsonData: null,
    build: function ( jsonData ) {
        jQuery( '.js-bloomingville-ipaper-productdetail' ).html( e4.handlebars.tmpl.bloomingvilleIpaperProductdetail( jsonData ) );
    }
};

function iPaperInit () {
    bloomingville.iPaper.onAPIReady( iPaperAPI );
}
